import { useTranslation } from "react-i18next";
import { cn } from "../../../../utils/cn";

interface Props {
  variant: "total" | "completed" | "flagged";
  count: number;
}

const QuestionCountBlock = ({ variant, count }: Props) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        "w-20 h-16 border rounded-lg flex flex-col justify-center items-center",
        variant === "total" && "border-border bg-bkg text-secondary",
        variant === "completed" &&
          "bg-[#F0FDF4] text-[#00875D] border-[#00875D]/25",
        variant === "flagged" && "bg-[#FDF1D0] text-amber-500 border-amber-200"
      )}
    >
      <span className="text-xs font-semibold">
        {variant === "total" && t("assessment.sectionCard.total")}
        {variant === "completed" && t("assessment.sectionCard.completed")}
        {variant === "flagged" && t("assessment.sectionCard.flagged")}
      </span>
      <span className="text-2xl font-semibold">{count}</span>
    </div>
  );
};

export default QuestionCountBlock;
